module.exports = __webpack_public_path__ + "media/img/icons/my_venues-36c31ca63a12ad1bc3c285e47c5bcd14.png";